/* eslint-disable camelcase */
import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { sess_put } from '../../../utils/HttpRequests';
import './VMNManagement.css';

const VMNAllot = () => {
  const [error, setError] = useState('');
  const [detail, setDetail] = useState({ newVMN: '', phoneNumber: '' });

  const onChange = (e) => {
    setDetail({ ...detail, [e.target.id]: e.target.value });
  };

  const allot = async () => {
    try {
      const params = {
        new_v_mobile_no: detail.newVMN,
        phone_number: detail.phoneNumber,
      };
      const sessionToken = localStorage.getItem('admin-panel-sessionToken');

      await sess_put('admin/console/update-doosra-number', sessionToken, params);
      setError('Alloted successfully');
      setDetail({ newVMN: '', phoneNumber: '' });
    } catch (err) {
      setDetail({ newVMN: '', phoneNumber: '' });
      setError(err?.response?.data?.error?.reason || err.message || 'something went wrong in allotment');
    }
  };

  return (
    <div style={{ textAlign: 'left', fontWeight: 'bolder' }}>
      <form className="form-horizontal">
        <div className="container">
          <div className="label">Allot No</div>
          <div className="inputs-fl-2">
            <input className="form-control" type="number" placeholder="10 digit registered No" id="phoneNumber" value={detail.phoneNumber} onChange={onChange} />
            <span style={{ color: 'green' }}>**10 digit</span>
          </div>
          <div className="inputs-fl-1">
            <input className="form-control" type="number" placeholder="Enter New VMN" id="newVMN" value={detail.newVMN} onChange={onChange} />
            <span style={{ color: 'green' }}>**10 digit (91 is optional)</span>
          </div>
          <div className="inputs-fl-1">
            <Button variant="danger" onClick={allot}>allot</Button>
          </div>

          {error && <div className="label" style={{ color: 'red' }}>{error}</div>}
        </div>

      </form>
    </div>
  );
};

export default VMNAllot;
